// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-label[data-v-c413f20c]{text-transform:none}.select-menu-item[data-v-c413f20c]:hover{opacity:0.9}\n", ""]);
// Exports
module.exports = exports;
